import { logger } from './../constants';
import { getGTMId } from '../tag-manager-utils';
import { getScriptGTM } from './gtm-script';
import { GTMStateLoader } from './gtm-state-loader';
import { States } from './state-loader';
class Loader{  
  constructor() {
    this.pendingPromises = [];
  }
  isGTMReady() {
    const state = GTMStateLoader.getState();
    return new Promise((resolve, reject) => {
      switch (state) {
        case States.INIT: // 1
          // eslint-disable-next-line no-console
          logger(`## Tagmanager - GTM is not initialized - ${state} - add to pending list`);
          this.pendingPromises.push({
            resolve,
            reject
          });
          break;
        case States.LOADING: // 2
          // eslint-disable-next-line no-console
          logger(`## Tagmanager - GTM is loading - ${state} - add to pending list`);
          this.pendingPromises.push({
            resolve,
            reject
          });
          break;
        case States.LOADED: // 3
          // eslint-disable-next-line no-console
          logger(`## Tagmanager - GTM is ready - ${state}`);
          resolve(true);
          break;
        default: // 0
          // eslint-disable-next-line no-console
          logger(`## Tagmanager - GTM is in error - ${state}`);
          reject(state);
          break;
      }
    });
  }

  loadGTM(successCallback, errorCallback) {
    if (document.querySelector('script#gtm-script') == null) {
      GTMStateLoader.updateState(States.LOADING);
      const gtmId = getGTMId();
      getScriptGTM(gtmId).then((id) => {
        GTMStateLoader.updateState(States.LOADED);
        successCallback && typeof successCallback == 'function' && successCallback(id);
      }).catch((err) => {
        // eslint-disable-next-line no-console
        logger('catch error', err);
        GTMStateLoader.updateState(States.ERROR);
        errorCallback && typeof errorCallback == 'function' && errorCallback(err);
      }).finally(() => {
        const state = GTMStateLoader.getState();
        // eslint-disable-next-line no-console
        logger(`## Tagmanager - Loading GTM - finally - ${state} - processing pending promises`, this.pendingPromises.length);
        this.pendingPromises.map(p => {
          if (state.equals(States.LOADED)) {
            p.resolve(true);
          } else {
            p.reject(state);
          }
        });
        this.pendingPromises.length = 0; // clear array
      });
    } else {
      // eslint-disable-next-line no-console
      console.warn('## Tagmanager - GTM script already loaded');
    }
  }
}

let loader = window.Xloader
if (!window.Xloader){
  loader = new Loader();
  window.Xloader = loader
}
export const GTMloader = loader
